// About: what Ventholes is, and who built it.

import { useStore } from '../state/store'
import { IconBrand, IconClose, NotumMark } from './icons'

export function AboutDialog() {
  const setOverlay = useStore((s) => s.setOverlay)
  return (
    <div className="dialog about holo-frame" role="dialog" aria-modal="true" aria-label="About Ventholes">
      <div className="dialog-head">
        <IconBrand size={16} />
        <h2>About</h2>
        <button className="quiet icon-btn" onClick={() => setOverlay(null)} aria-label="Close (Esc)">
          <IconClose size={13} />
        </button>
      </div>
      <div className="dialog-body">
        <div className="about-app">
          <div className="about-title">
            <IconBrand size={28} />
            <div>
              <div className="about-name">Ventholes</div>
              <div className="about-version">version 2</div>
            </div>
          </div>
          <p>
            A parametric hole pattern generator for panels, grilles, and vents. Nine layout
            modes, four gradient channels with on-canvas controllers, image-driven halftones,
            and a custom shape editor.
          </p>
          <p>
            Exports are built to be trusted: SVG and DXF for cutting, watertight STL for
            printing, and STEP panel solids that open cleanly in CAD. Everything runs in your
            browser. No uploads, no account; designs autosave locally and travel inside the
            files you export.
          </p>
        </div>

        <div className="about-notum">
          <a
            className="about-notum-mark"
            href="https://n-r.hr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Notum Robotics website"
          >
            <NotumMark size={44} />
          </a>
          <div className="about-notum-text">
            <div className="about-notum-name">Made by Notum Robotics</div>
            <div className="about-notum-tagline">We build what off-the-shelf can't.</div>
            <a className="about-link" href="https://n-r.hr" target="_blank" rel="noopener noreferrer">
              n-r.hr
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
